export default "__VITE_ASSET__BpTZdJKN__"